export default {
  2011: {
    items: [
      "Afghanistan",
      "Austria",
      "Bangladesh",
      "Bosnia and Herzegovina",
      "Brazil",
      "Burma (Republic of the Union of Myanmar)",
      "Chile",
      "China (excludes SARs and Taiwan)",
      "Congo, Democratic Republic of",
      "Croatia",
      "El Salvador",
      "Egypt",
      "England",
      "Eritrea",
      "Ethiopia",
      "Fiji",
      "North Macedonia",
      "France",
      "Germany",
      "Greece",
      "Hong Kong (SAR of China)",
      "Hungary",
      "India",
      "Indonesia",
      "Iraq",
      "Iran",
      "Italy",
      "Japan",
      "Kenya",
      "Korea, Republic of (South)",
      "Lebanon",
      "Liberia",
      "Malaysia",
      "Netherlands",
      "New Zealand",
      "Nigeria",
      "Pakistan",
      "Philippines",
      "Poland",
      "Portugal",
      "Russian Federation",
      "Scotland",
      "Singapore",
      "Somalia",      
      "South Africa",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Syria",
      "Tanzania",
      "Thailand",
      "Türkiye",
      "Vietnam"
    ]
  },
  2016: {
    items: [
      "Afghanistan",
      "Austria",
      "Bangladesh",
      "Bosnia and Herzegovina",
      "Brazil",
      "Chile",
      "China (excludes SARs and Taiwan)",
      "Congo, Democratic Republic of",
      "Croatia",
      "El Salvador",
      "Egypt",
      "England",
      "Eritrea",
      "Ethiopia",
      "Fiji",
      "North Macedonia",
      "France",
      "Germany",
      "Greece",
      "Hong Kong (SAR of China)",
      "Hungary",
      "India",
      "Indonesia",
      "Iraq",
      "Iran",
      "Italy",
      "Japan",
      "Kenya",
      "Korea, Republic of (South)",
      "Lebanon",
      "Liberia",
      "Malaysia",
      "Burma (Republic of the Union of Myanmar)",
      "Netherlands",
      "New Zealand",
      "Nigeria",
      "Pakistan",
      "Philippines",
      "Poland",
      "Portugal",
      "Russian Federation",
      "Scotland",
      "Singapore",
      "Somalia",
      "South Africa",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Syria",
      "Tanzania",
      "Thailand",
      "Türkiye",
      "Vietnam"
    ]
  },
  2021: {
    items: [
      "Afghanistan",
      "Austria",
      "Bangladesh",
      "Bosnia and Herzegovina",
      "Brazil",
      "Chile",
      "China (excludes SARs and Taiwan)",
      "Congo, Democratic Republic of",
      "Croatia",
      "El Salvador",
      "Egypt",
      "England",
      "Eritrea",
      "Ethiopia",
      "Fiji",
      "North Macedonia",
      "France",
      "Germany",
      "Greece",
      "Hong Kong (SAR of China)",
      "Hungary",
      "India",
      "Indonesia",
      "Iraq",
      "Iran",
      "Italy",
      "Japan",
      "Kenya",
      "Korea, Republic of (South)",
      "Lebanon",
      "Liberia",
      "Malaysia",
      "Burma (Republic of the Union of Myanmar)",
      "Netherlands",
      "New Zealand",
      "Nigeria",
      "Pakistan",
      "Philippines",
      "Poland",
      "Portugal",
      "Russian Federation",
      "Scotland",
      "Singapore",
      "Somalia",
      "South Africa",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Syria",
      "Tanzania",
      "Thailand",
      "Türkiye",
      "Vietnam"
    ]
  }
};



// WEBPACK FOOTER //
// ../data/qld/birthplace.js